document.addEventListener('DOMContentLoaded', () => {
  const GWP_VARIANT_IDS = [40814178467906, 40814178500674];
  const QUALIFYING_VARIANT_IDS = ['42088335966274', '42091514200130'];

  function addGWP(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          '_Gift With Purchase': 'true'
        }
      })
    }).then(() => {
      refreshCartDrawer();
      refreshGWPSection();
    });
  }

  function bindGWPButtons() {
    document.querySelectorAll('[data-gwp-variant]').forEach(btn => {
      btn.removeEventListener('click', handleGWPClick);
      btn.addEventListener('click', handleGWPClick);
    });
  }

  function handleGWPClick(event) {
    const variantId = event.currentTarget.getAttribute('data-gwp-variant');
    addGWP(variantId);
  }

  async function enforceSingleGWP() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const gwpItems = cart.items.filter(item =>
        GWP_VARIANT_IDS.includes(item.variant_id)
      );

      const qualifyingItems = cart.items.filter(item =>
        QUALIFYING_VARIANT_IDS.includes(String(item.variant_id))
      );

      const operations = [];

      // Reset quantity to 1
      gwpItems.forEach(item => {
        if (item.quantity > 1) {
          operations.push(setLineQuantity(item.key, 1));
        }
      });

      // Remove duplicates
      if (gwpItems.length > 1) {
        gwpItems.slice(1).forEach(item => {
          operations.push(removeLine(item.key));
        });
      }

      // Remove if no longer qualified
      if (qualifyingItems.length === 0 && gwpItems.length > 0) {
        gwpItems.forEach(item => {
          operations.push(removeLine(item.key));
        });
      }

      if (operations.length > 0) {
        await Promise.all(operations);
        await refreshCartDrawer();
        await refreshGWPSection();
      }

    } catch (err) {
      console.error('GWP enforcement error:', err);
    }
  }

  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function setLineQuantity(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
  }

function refreshCartDrawer() {
  return fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');
      const oldDrawer = document.querySelector('cart-drawer');
      if (newDrawer && oldDrawer) {
        oldDrawer.innerHTML = newDrawer.innerHTML;
        oldDrawer.setAttribute('open', '');
        oldDrawer.dispatchEvent(new Event('section:load', { bubbles: true }));
        document.dispatchEvent(new Event('shopify:section:load'));
        bindGWPButtons(); // Rebinds GWP buttons

        // ✅ Forzar refresh inmediato del GWP tras el drawer refresh
        setTimeout(() => {
          refreshGWPSection();
        }, 100); // pequeño delay para asegurar que el drawer terminó de montarse
      }
    });
}


  function refreshGWPSection() {
    return fetch('/?section_id=custom-gwp-socks')
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGWP = doc.querySelector('#gwp-section') || doc.querySelector('.gwp-message');
        const currentGWP = document.querySelector('#gwp-section') || document.querySelector('.gwp-message');
        if (newGWP && currentGWP) {
          currentGWP.replaceWith(newGWP);
        } else if (!currentGWP && newGWP) {
          const container = document.querySelector('[data-gwp-container]') || document.querySelector('#CartDrawer-CartItems');
          if (container) container.appendChild(newGWP);
        }
        bindGWPButtons(); // Reattach
      });
  }

  document.body.addEventListener('click', event => {
    if (
      event.target.closest('[data-cart-quantity-adjust]') ||
      event.target.closest('cart-remove-button')
    ) {
      setTimeout(() => {
        enforceSingleGWP().then(refreshGWPSection);
      }, 300);
    }
  });

  document.addEventListener('shopify:section:load', () => {
    enforceSingleGWP();
    refreshGWPSection();
  });

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.addedNodes.length > 0) {
          const addedGWPButtons = Array.from(mutation.addedNodes).some(node => {
            return node.nodeType === 1 && node.querySelector?.('[data-gwp-variant]');
          });
  
          if (addedGWPButtons) {
            // Reenlaza botones y asegura actualización
            bindGWPButtons();
          }
        }
      }
    });
  
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }


  enforceSingleGWP();
  refreshGWPSection();
});

  document.addEventListener('shopify:section:load', () => {
  enforceSingleGWP().then(refreshGWPSection);
});
